module.exports = "/images/tiny.png?2c0c97aadb608ced7547dc6c859edce2";